module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "ProfitLossDashboardpdf",
    attrs: {
      "id": "ProfitLossDashboardpdf"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mr-1"
  }, [_c('div', [_c('b-navbar', [_c('b-navbar-brand', {
    staticStyle: {
      "padding": "0.475rem 1rem"
    }
  }, [_c('h3', [_vm._v("Assignment P&L Dashboard")])]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [(_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Filter-Agency-Modal') : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('FilterCBModal') : _vm._e(), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CustomDateList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select",
      "isDisabled": _vm.Filter.QFlag
    },
    on: {
      "input": _vm.getCurrentLastDate
    },
    model: {
      value: (_vm.Filter.QDFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "QDFilter", $$v)
      },
      expression: "Filter.QDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Assignment Date")]), _c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "ass_date-datepicker",
      "placeholder": "YYYY-MM-DD",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.Filter.ass_date),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ass_date", $$v)
      },
      expression: "Filter.ass_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SOB Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Select SOB Date",
      "id": "newClientName",
      "name": "newClientName",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.Filter.sob_date),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "sob_date", $$v)
      },
      expression: "Filter.sob_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.clientfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientfilter", $$v)
      },
      expression: "Filter.clientfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Pickup")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.Filter.PICKfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PICKfilter", $$v)
      },
      expression: "Filter.PICKfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Handover")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.Filter.HANDfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HANDfilter", $$v)
      },
      expression: "Filter.HANDfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR');
        _vm.getProfitLossData('Normal');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getProfitLossData('Normal');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getProfitLossData('Normal');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.POLfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLfilter", $$v)
      },
      expression: "Filter.POLfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getProfitLossData('Normal');
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.FPODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODfilter", $$v)
      },
      expression: "Filter.FPODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FCL/LCL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.fclLclFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fclLclFilter", $$v)
      },
      expression: "Filter.fclLclFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.transportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transportTypeFilter", $$v)
      },
      expression: "Filter.transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Ass. No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Ass. No Filter",
      "id": "assignmentNoFilter",
      "name": "assignmentNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.assignmentNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentNoFilter", $$v)
      },
      expression: "Filter.assignmentNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "CommonFilter",
      "name": "CommonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getProfitLossData('Normal')
      }
    },
    model: {
      value: (_vm.Filter.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CommonFilter", $$v)
      },
      expression: "Filter.CommonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-card', [_c('b-row', {
    staticClass: "mb-2 p-2 ml-2 mr-2",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.03)"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('md-layout', {
    staticClass: "pull-right",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.getProfitLossFilterList.length > 0) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.generatePLPDF
    }
  }, [_vm._v("\n                  Generate PDF\n                ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": _vm.Filter.CommonFilter ||
        _vm.Filter.ass_date ||
        _vm.Filter.sob_date ||
        _vm.Filter.branchfilter ||
        _vm.Filter.shippingLineFilter ||
        _vm.Filter.fclLclFilter ||
        _vm.Filter.transportTypeFilter ||
        _vm.Filter.clientIdFilter ||
        _vm.Filter.PORfilter ||
        _vm.Filter.PODfilter ||
        _vm.Filter.POLfilter ||
        _vm.Filter.FPODfilter ||
        _vm.Filter.containerTypeFilter ||
        _vm.Filter.assignmentNoFilter ||
        _vm.Filter.QDFilter ||
        _vm.Filter.QFlag ||
        _vm.Filter.DFlag ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ||
        _vm.Filter.dateRange.PICKfilter ||
        _vm.Filter.dateRange.HANDfilter ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.CommonFilter ||
    _vm.Filter.ass_date ||
    _vm.Filter.sob_date ||
    _vm.Filter.branchfilter ||
    _vm.Filter.shippingLineFilter ||
    _vm.Filter.fclLclFilter ||
    _vm.Filter.transportTypeFilter ||
    _vm.Filter.clientIdFilter ||
    _vm.Filter.PORfilter ||
    _vm.Filter.PODfilter ||
    _vm.Filter.POLfilter ||
    _vm.Filter.FPODfilter ||
    _vm.Filter.containerTypeFilter ||
    _vm.Filter.assignmentNoFilter ||
    _vm.Filter.QDFilter ||
    _vm.Filter.QFlag ||
    _vm.Filter.DFlag ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ||
    _vm.Filter.dateRange.PICKfilter ||
    _vm.Filter.dateRange.HANDfilter ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('Assignment_Profit_Loss_Dashboard', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.ExcelBtnName1 != 'Export Pending Module As Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('ModuleIDPending', 'Export Pending Module As Excel')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ExcelBtnName1) + "\n                  "), (_vm.ExcelBtnName1 != 'Export Pending Module As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n                  Back\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-tabs', {
    attrs: {
      "pills": "",
      "card": ""
    },
    model: {
      value: (_vm.PLtabIndex),
      callback: function($$v) {
        _vm.PLtabIndex = $$v
      },
      expression: "PLtabIndex"
    }
  }, [(_vm.pageType == 'Profit_less_15' || _vm.pageType == 'Loss_less_15') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.perCondList,
      "option-value": "perVal",
      "option-text": "perText",
      "placeholder": "Select Condition"
    },
    on: {
      "input": function($event) {
        _vm.getTabStatus(_vm.pageType)
      }
    },
    model: {
      value: (_vm.perCon),
      callback: function($$v) {
        _vm.perCon = $$v
      },
      expression: "perCon"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Condition Value")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Condition Value",
      "id": "perVal",
      "name": "perVal",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getTabStatus(_vm.pageType)
      }
    },
    model: {
      value: (_vm.perVal),
      callback: function($$v) {
        _vm.perVal = $$v
      },
      expression: "perVal"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Billing Locked",
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Compare')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "All"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('All')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Profit"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Profit')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": 'Profit ' + _vm.perCon + ' ' + _vm.perVal + '%'
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Profit_less_15')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Profit Locked"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Profit_locked')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Loss"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Loss')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": 'Loss ' + _vm.perCon + ' ' + _vm.perVal + '%'
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Loss_less_15')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Loss Locked"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Loss_locked')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Normal"
    },
    on: {
      "click": function($event) {
        _vm.getTabStatus('Normal')
      }
    }
  }, [_c('b-card-text', [_c('PL-Table', {
    attrs: {
      "tableData": _vm.getProfitLossFilterList,
      "PLFields": _vm.PLFields,
      "totalRowsCount": this.totalRows
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-124d1248","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/profitlossDashboard.vue
// module id = 2402
// module chunks = 0